module.exports = __webpack_public_path__ + "img/icon04.a749ec89.png";